<template>
  <step-progress
    :steps="steps"
    :current-step="progressStep.step"
    icon-class="fa fa-check"
    :current-icon-class="progressStep.activeIconClass"
    :active-thickness="2"
    :passive-thickness="2"
    :line-thickness="2"
    active-color="#1976d2"
    :current-step-color="progressStep.currentStepColor"
    :show-status-in-bubble="true"
    :show-step-on-hover="true"
    :is-processing="progressStep.isProcessing"
    :blink-active="progressStep.isProcessing"
  ></step-progress>
</template>

<script>
import StepProgress from '@/components/StepProgress';
import '@fortawesome/fontawesome-free/css/all.min.css';

export default {
  name: 'TaskStepProgress',
  components: {
    'step-progress': StepProgress
  },
  props: {
    steps: {
      type: Array,
      default() { return []; },
      validator(val) {
        return val && val.length > 0;
      }
    },
    progressStep: {
      type: Object,
      default: {}
    },
  },
};
</script>

<style scoped>
.step-progress__wrapper {
  width: 160px;
}

::v-deep .step-progress__bar {
  height: 40px;
  margin-bottom: 5px;
}

::v-deep .step-progress__step span {
  font-size: 12px;
}

@media (max-width: 767px) {
  ::v-deep .step-progress__step span {
    font-size: 10px;
  }
}

::v-deep .step-progress__step:after {
  height: 20px;
  width: 20px;
}

@media (max-width: 767px) {
  ::v-deep .step-progress__step:after {
    height: 16px;
    width: 16px;
  }
}

::v-deep .step-progress__step-label {
  font-size: 10px;
}

::v-deep .step-progress__step-icon {
  font-size: 14px;
}

@media (max-width: 767px) {
  ::v-deep .step-progress__step-icon {
    font-size: 12px;
  }
}

::v-deep .step-progress__bubble {
  bottom: calc(100% + 10px);
  padding: 4px 8px;
  font-size: 12px;
}

::v-deep .step-progress__bubble--first {
  left: -25px;
}

::v-deep .step-progress__bubble--last {
  right: -25px;
}

</style>
